import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'

const initialState = {
  path: '',
  records: [],
  page: 1,
  rowsPerPage: 10,
  totalRows: 0,
  totalPage: 0,
  anchorEl: null,
  search: {},
  isFetching: true,
}

const puzzleHome = (state = initialState, action) => {
  var totalRows, totalPage
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, path: action.payload.location.pathname, anchorEl: null }
    case types.puzzleHome.RESET:
      return deepCopy(initialState)
    case types.puzzleHome.pageNavigation.NEXT_PAGE:
      if (state.page + 1 > state.totalPage) {
        return state
      }
      return { ...state, page: state.page + 1 }
    case types.puzzleHome.pageNavigation.BACK_PAGE:
      if (state.page - 1 < 1) {
        return state
      }
      return { ...state, page: state.page - 1 }
    case types.puzzleHome.pageNavigation.CLEAR:
      return { ...state, page: 1, search: {} }
    case types.puzzleHome.menu.OPEN:
      return { ...state, anchorEl: action.anchorEl }
    case types.puzzleHome.menu.CLOSE:
      return { ...state, anchorEl: null }
    case types.fetch.puzzle.RESPONSE_SELECT:
      if (action.response.records === undefined) {
        return { ...state, records: [], isFetching: false }
      }
      totalRows = action.response.total ? parseInt(action.response.total, 10) : 0
      totalPage = Math.ceil(totalRows / state.rowsPerPage)
      return {
        ...state,
        records: action.response.records,
        search: action.response.search,
        totalRows,
        totalPage,
        isFetching: false
      }
    default:
      return state
  }
}

export default puzzleHome



// WEBPACK FOOTER //
// ./src/reducers/Page/Puzzle/PuzzleHome.js